import React from 'react'
import { Box, Flex } from '@chakra-ui/react'
import {
  GoogleReCaptchaProvider,
} from 'react-google-recaptcha-v3'
import RegisterSuscription from 'components/subscription/RegisterSuscription/registerSubscription'
import Form from 'providers/FormProvider'

const ValidateIdentity = () => {
  const initValues = {
    nacionality: 'Argentina',
    document: '',
    documentForeign: '',
    documentType: 'cuil',
    clave: ''
  }
  return (
    <Flex>
      <Box flex='1' id='right-side' px='6' py='0'>
        <Form initialValues={initValues}>
          <GoogleReCaptchaProvider language="es-AR" reCaptchaKey={process.env.GOOGLE_RECAPTCHA_SITE_KEY}>
            <RegisterSuscription isValidateIdentity />
          </GoogleReCaptchaProvider>
        </Form>
      </Box>
    </Flex>
  )
}

export default ValidateIdentity